import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchPlaceholder: {
		// eslint-disable-next-line jira/i18n/id-named-by-package
		id: 'servicedesk-customer-service-custom-details.common.field.user-field.search-placeholder-non-final',
		defaultMessage: 'Search for people',
		description: 'Placeholder text for searching for a user in the user picker',
	},
});
